module.exports = __webpack_public_path__ + "images/images/drawer-logo-full-logo_ppa-503e63c20208e65935976e945417e3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/drawer-logo-full-logo_ppa.png
// module id = 2526
// module chunks = 2